import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import {
  GeneratedAssignment,
  GeneratedAssignmentAttempt,
  GeneratedCreateAssignmentAttempt,
  GeneratedUpdateAssignmentAttempt,
} from '@repo/backend-api-spec';
import { BaseAPI } from './base-api';

@Injectable({
  providedIn: 'root',
})
export abstract class AssignmentApiService extends BaseAPI {
  public async getAssignment<T extends GeneratedAssignment = GeneratedAssignment>(assignmentUid: string) {
    return await lastValueFrom(this.get<T, 'NOT_FOUND'>(`/homework/assignment/${assignmentUid}`));
  }

  public async createAssignmentAttempt(assignmentUid: string, data: GeneratedCreateAssignmentAttempt) {
    return await lastValueFrom(
      this.post<GeneratedCreateAssignmentAttempt, GeneratedAssignmentAttempt, 'NOT_FOUND'>(
        `/homework/assignment/${assignmentUid}/attempt`,
        {
          body: data,
        },
      ),
    );
  }

  public async updateAssignmentAttempt(attemptUid: string, data: GeneratedUpdateAssignmentAttempt) {
    return await lastValueFrom(
      this.put<GeneratedUpdateAssignmentAttempt, GeneratedAssignmentAttempt, 'NOT_FOUND'>(`/homework/attempt/${attemptUid}`, {
        body: data,
      }),
    );
  }
}
